import React from 'react'
import { Divider, Typography } from 'antd'
const { Title } = Typography
import { Account, AccountsGrid } from '@/widgets/accountsGrid'
import {
  CardDescription,
  CardHeader,
  SectionCard,
} from '@/shared/ui/layout/styled'
import { Icon } from '@/shared/ui/Icon/Icon'
import { SYSTEM_TYPE, useSystemStore } from '@/app/store/systemStore'

interface SourceAccountCardProps {
  accounts: Account[]
  selectedAccount: string
  onAccountSelect: (accountId: string) => void
  isLoading: boolean
  currentPage?: number
}

export const SourceAccountCard: React.FC<SourceAccountCardProps> = ({
  accounts,
  selectedAccount,
  onAccountSelect,
  isLoading,
  currentPage,
}) => {
  const { selectedSystem } = useSystemStore()
  const isGlonassoft = selectedSystem === SYSTEM_TYPE.GLONASSOFT
  return (
    <SectionCard>
      <CardHeader gap={8}>
        <Icon name="account_tree" size={32} />
        <Title level={2}>
          {isGlonassoft
            ? 'Выберите клиента из которого необходимо перенести данные'
            : 'Выбор учетной записи для переноса данных'}
        </Title>
      </CardHeader>
      <Divider />
      {!isGlonassoft && (
        <CardDescription>
          Выберите учетную запись из которой будут переноситься данные.
        </CardDescription>
      )}
      <AccountsGrid
        accounts={accounts}
        selectedAccounts={[selectedAccount]}
        onAccountSelect={onAccountSelect}
        isLoading={isLoading}
        searchLabel={isGlonassoft ? 'Клиенты' : 'Учетная запись'}
        currentPage={currentPage}
      />
    </SectionCard>
  )
}
